import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";
import { UserCircle, KeyRound } from "lucide-react";
import { FotoPerfilCard } from "../components/FotoPerfilCard";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-blue-500";

const MeuPerfil = () => {
  const { auth, trocarSenha } = useApp();
  const { toast } = useToast();
  const [f, setF] = useState({ atual: "", nova: "", confirma: "" });
  const [saving, setSaving] = useState(false);

  const salvar = async () => {
    if (!f.atual || !f.nova) { toast({ title: "Preencha a senha atual e a nova senha" }); return; }
    if (f.nova.length < 6) { toast({ title: "A nova senha deve ter pelo menos 6 caracteres" }); return; }
    if (f.nova !== f.confirma) { toast({ title: "A confirmação não confere com a nova senha" }); return; }
    setSaving(true);
    try {
      await trocarSenha(f.atual, f.nova);
      toast({ title: "Senha alterada com sucesso" });
      setF({ atual: "", nova: "", confirma: "" });
    } catch (e) {
      toast({ title: "Não foi possível alterar", description: e?.response?.data?.detail || "Verifique a senha atual." });
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg space-y-6" data-testid="meu-perfil-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><UserCircle className="w-6 h-6 text-blue-600" /> Meu Perfil</h1>
        <p className="text-sm text-slate-500">Gerencie sua conta e altere sua senha quando precisar.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-1">
        <p className="text-sm text-slate-500">Nome</p>
        <p className="font-semibold text-slate-800" data-testid="perfil-nome">{auth?.nome || "-"}</p>
        <p className="text-sm text-slate-500 mt-3">Perfil de acesso</p>
        <p className="font-medium text-slate-700 capitalize" data-testid="perfil-tipo">{auth?.perfil || auth?.cargo || "-"}</p>
      </div>

      <FotoPerfilCard />

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
        <h2 className="font-semibold text-slate-800 flex items-center gap-2"><KeyRound className="w-4 h-4 text-amber-600" /> Alterar senha</h2>
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-slate-500">Senha atual</label>
          <input type="password" className={inputCls} value={f.atual} onChange={(e) => setF((x) => ({ ...x, atual: e.target.value }))} data-testid="senha-atual" />
        </div>
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-slate-500">Nova senha (mín. 6 caracteres)</label>
          <input type="password" className={inputCls} value={f.nova} onChange={(e) => setF((x) => ({ ...x, nova: e.target.value }))} data-testid="senha-nova" />
        </div>
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-slate-500">Confirmar nova senha</label>
          <input type="password" className={inputCls} value={f.confirma} onChange={(e) => setF((x) => ({ ...x, confirma: e.target.value }))} data-testid="senha-confirma" />
        </div>
        <Button className="bg-blue-600 hover:bg-blue-700" onClick={salvar} disabled={saving} data-testid="senha-salvar">{saving ? "Salvando..." : "Alterar senha"}</Button>
      </div>
    </div>
  );
};

export default MeuPerfil;
